module.exports = __webpack_public_path__ + "media/images/pengurus/komisaris-utama-99a14391f1bcde8a0755e05881531634.jpeg";